// LoginPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [keepSignedIn, setKeepSignedIn] = useState(false);
  const navigate = useNavigate();


  const handleLogin = (e) => {
    e.preventDefault();
    // Handle authentication logic here
     if (username && password) {
      navigate("/dashboard"); // ✅ Go to Dashboard
    } else {
      alert("Please enter both username and password.");
    }
    console.log({ username, password, keepSignedIn });
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h2 className="login-header">Welcome Back</h2>
        <form onSubmit={handleLogin} className="login-form">
          <label htmlFor="username">Username</label>
          <input
            id="username"
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div className="login-options">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={keepSignedIn}
                onChange={(e) => setKeepSignedIn(e.target.checked)}
              />
              Keep me signed in
            </label>
          </div>

          <button type="submit" className="login-button">
            Login
          </button>

          <a href="/help" className="help-link">
            Need Help?
          </a>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
